import enroll from './enroll'
import enrollQuery from './enroll-query'
import certQuery from './cert-query'

const training = {
  path: 'training',
  component: resolve => require(['../../../../pages/portal/sbs/training'], resolve),
  redirect: 'training/enroll',
  children: [
    enroll,
    enrollQuery,
    certQuery
  ]
}

export default training
